import React, { useState } from 'react';
import { 
  FaGraduationCap, FaShieldAlt, FaCheckCircle, FaChevronDown, 
  FaGlobe, FaHandHoldingUsd, FaFileAlt, FaPercent, FaBookReader 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const EducationLoan = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "What expenses are covered under an education loan?",
      a: "Comprehensive education loans cover virtually all academic expenses. This includes tuition fees payable to the school or university, hostel/accommodation fees, examination and library fees, purchase of books, equipment, laptops, uniforms, and even travel expenses for studies abroad."
    },
    {
      q: "What is a moratorium period, and when does repayment start?",
      a: "A moratorium period is a grace period during which you are not required to start repaying the principal amount. Typically, it covers the entire duration of the course plus an additional 6 months to 1 year post-graduation to help the student secure employment before EMIs begin."
    },
    {
      q: "Can I get a collateral-free education loan for studying abroad?",
      a: "Yes. Many of our banking and NBFC partners offer unsecured (collateral-free) education loans up to substantial amounts (often ranging from ₹20 Lakhs to ₹50 Lakhs) for premier universities and eligible courses abroad, depending on the student's academic profile and co-applicant income."
    },
    {
      q: "Do education loans offer tax benefits?",
      a: "Yes. Under Section 80E of the Income Tax Act, the interest paid on an education loan is eligible for tax deductions for a maximum of 8 successive financial years starting from the year the repayment begins, with no upper cap on the deduction amount."
    }
  ];

  return (
    <main className="education-loan-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Education Loan Services in Hyderabad | Student Loan Advisors | Lotoswealth</title>

  <meta
    name="description"
    content="Lotoswealth provides Education Loan Services in Hyderabad, helping students secure loans for higher education in India and abroad with competitive interest rates, quick approvals, flexible repayment options, and expert loan advisory services."
  />

  <meta
    name="keywords"
    content="Education Loan Hyderabad, Education Loan Services Hyderabad, Student Loan Hyderabad, Higher Education Loan Hyderabad, Study Abroad Loan Hyderabad, Overseas Education Loan Hyderabad, Education Finance Hyderabad, College Education Loan Hyderabad, University Education Loan Hyderabad, Student Loan Advisor Hyderabad, Education Loan Consultant Hyderabad, Education Loan Interest Rates Hyderabad, Education Loan EMI Hyderabad, Education Loan Without Collateral Hyderabad, Education Loan with Collateral Hyderabad, Loan Advisor Hyderabad, Financial Advisor Hyderabad, Student Finance Hyderabad, Study Loan Hyderabad, Lotoswealth"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link
    rel="canonical"
    href="https://www.lotoswealth.com/education-loan"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta
    property="og:url"
    content="https://www.lotoswealth.com/education-loan"
  />
  <meta
    property="og:title"
    content="Education Loan Services in Hyderabad | Lotoswealth"
  />
  <meta
    property="og:description"
    content="Get the best Education Loan Services in Hyderabad with Lotoswealth. Finance your higher education in India or abroad with competitive interest rates, flexible repayment options, and expert loan guidance."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Education Loan Services in Hyderabad | Lotoswealth"
  />
  <meta
    name="twitter:description"
    content="Apply for an Education Loan in Hyderabad with Lotoswealth. Expert guidance for student loans, study abroad loans, competitive interest rates, and hassle-free approvals."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/education-loan.jpg" 
            alt="Education Loan Solutions" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Global & Domestic Education Loans
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Fund Your Academic Ambitions Without Financial Boundaries
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth. Quality education is the most powerful investment you can make in your future. Our education loan advisory services connect students and parents with specialized lenders offering competitive rates, high sanction limits, and flexible moratorium terms for studies in India and across the globe.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Whether you are pursuing an undergraduate degree, a specialized master's program, or an Ivy League education abroad, we guide you through collateral-free financing options, visa-friendly loan sanction letters, and seamless university disbursements.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Turn your academic dreams into reality with comprehensive funding, tax-saving benefits, and dedicated advisory support every step of the way.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY CHOOSE OUR EDUCATION LOANS (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Why Finance Your Education Through Lotoswealth?
              </h2>
              <p className="text-muted line-height-lg">
                Navigating education financing can be overwhelming for students and families. From university-specific compliance to visa sanction letter requirements, small errors can cause costly delays in admission timelines.
              </p>
              <p className="text-muted line-height-lg">
                We partner with premier public banks, private lenders, and specialized international NBFCs to secure high-value loans with attractive interest rates, extensive moratorium benefits, and complete coverage of living and tuition expenses.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">Key Loan Advantages</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>100% Expense Coverage:</strong> Tuition, housing, travel, and laptop costs included.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Collateral-Free Options:</strong> Unsecured loans available for premier institutions.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Moratorium Period:</strong> Repayment flexibility extending past graduation.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Tax Savings (Sec 80E):</strong> Claim deductions on entire loan interest payouts.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. OUR EDUCATION LOAN OFFERINGS (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🎓 Our Education Financing Solutions</h2>
            <p className="text-white">Comprehensive loan options structured for domestic and international programs.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-lg-4 col-md-6 animate-slide-up delay-1">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaGlobe size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Study Abroad Loans</h5>
                <p className="text-muted small">High-value funding for universities in the US, UK, Canada, Australia, Europe, and beyond, supporting tuition, living costs, and visa processing.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaGraduationCap size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Domestic Higher Education</h5>
                <p className="text-muted small">Affordable loans for premier Indian institutions including IITs, IIMs, NITs, medical colleges, and top-tier universities with preferential interest rates.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaShieldAlt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Collateral-Free (Unsecured) Loans</h5>
                <p className="text-muted small">Specialized unsecured financing options designed for eligible students heading to recognized global universities without pledging physical property.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-4">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBookReader size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Executive & Professional Courses</h5>
                <p className="text-muted small">Funding solutions for working professionals pursuing executive MBAs, certifications, and specialized postgraduate programs.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-5">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaHandHoldingUsd size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Pre-Visa Sanction Letters</h5>
                <p className="text-muted small">Fast-tracked loan sanction letters required by embassies and consulates as official financial proof during visa application interviews.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-6">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaPercent size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Refinancing & Balance Transfer</h5>
                <p className="text-muted small">Transfer your existing high-interest education loan to a lender offering lower interest rates to reduce your overall repayment burden.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          4. OUR 5-STEP LOAN PROCESS (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 Our Streamlined Loan Process</h2>
            <p className="text-light opacity-75">From application to university fee disbursal in 5 easy steps.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 1 – Profile & Course Assessment</h5>
                <p className="small text-muted mb-0">We review the student's academic profile, university admission status, and financial requirements to match the best lending partner.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 2 – Lender Matching & Quotation</h5>
                <p className="small text-muted mb-0">Comparing interest rates, moratorium terms, and processing fees across public banks and private NBFCs.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 3 – Document Collection & Filing</h5>
                <p className="small text-muted mb-0">Assisting with academic records, co-applicant financial papers, KYC, and collateral documents (if applicable).</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 4 – Fast Sanction & Visa Letter</h5>
                <p className="small text-muted mb-0">Securing formal loan sanction approval and generating official financial proof letters required for student visa processing.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 5 – Timely Disbursal</h5>
                <p className="small text-muted mb-0">Coordinating direct fee transfers to universities and managing living expense disbursements as per academic schedules.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Can Apply for an Education Loan?</h3>
              <p className="text-muted small mb-4">Our education financing services support students across all academic paths:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "Study Abroad Aspirants", "Undergraduate Students",
                  "Postgraduate & Master's Candidates", "MBA & Executive Students",
                  "Medical & Engineering Students", "Students Needing Collateral-Free Loans",
                  "Parents & Co-Applicants", "Working Professionals Upskilling"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Trust Lotoswealth for Education Loans?</h3>
                <p className="text-muted small mb-4">Securing education funding requires careful planning and banking expertise. Clients trust us because we offer:</p>
                <div className="row g-3">
                  {[
                    "Tie-Ups with Top Public & Private Lenders", "High Unsecured Loan Approvals",
                    "Visa-Friendly Sanction Letter Support", "Complete Expense Coverage Guidance",
                    "Dedicated Loan Relationship Officers", "Transparent Interest Rates & Terms",
                    "End-to-End University Disbursal Support", "Tax Saving Guidance (Sec 80E)"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding Education Loans & Financing</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Fund Your Educational Journey?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Secure the right education loan with flexible terms and fast approvals. Connect with our student financing advisors today.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Apply for an Education Loan Today
          </button>
        </div>
      </section>

    </main>
  );
};

export default EducationLoan;